import { LocationChangeListener, LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';

/**
Keeps Angular Router state entirely inside this custom element.

It deliberately never calls window.history.pushState(),
window.history.replaceState(), or window.history.go().
The Shell (platform-shell) remains the sole owner of the browser
URL/history; this MFE's Router must not fight it for control.
*/
@Injectable()
export class MemoryLocationStrategy implements LocationStrategy {
  private currentPath = '/';
  private readonly popStateListeners = new Set<LocationChangeListener>();

  back(): void {
    // Intentionally no-op: Angular has no browser-history ownership.
  }

  forward(): void {
    // Intentionally no-op: Angular has no browser-history ownership.
  }

  getBaseHref(): string {
    return '/';
  }

  getState(): unknown {
    return null;
  }

  historyGo(): void {
    // Intentionally no-op: Angular has no browser-history ownership.
  }

  onPopState(function_: LocationChangeListener): void {
    this.popStateListeners.add(function_);
  }

  path(): string {
    return this.currentPath;
  }

  prepareExternalUrl(internal: string): string {
    return internal.startsWith('/') ? internal : `/${internal}`;
  }

  pushState(_state: unknown, _title: string, url: string, queryParameters: string): void {
    this.currentPath = this.composePath(url, queryParameters);
  }

  replaceState(_state: unknown, _title: string, url: string, queryParameters: string): void {
    this.currentPath = this.composePath(url, queryParameters);
  }

  private composePath(url: string, queryParameters: string): string {
    const normalizedUrl = url.startsWith('/') ? url : `/${url}`;

    return queryParameters ? `${normalizedUrl}?${queryParameters}` : normalizedUrl;
  }
}
